export default __webpack_public_path__ + "static/media/purple.abc5334f.png";